var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"underline pointer",on:{"click":function($event){return _vm.TogglePubilsh()}}},[_vm._v("\n  "+_vm._s(_vm.isPublish)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }